import { render } from "./SideMenu.vue?vue&type=template&id=79f86886"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SideMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79f86886"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79f86886', __exports__)) {
    api.reload('79f86886', __exports__)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=79f86886", () => {
    api.rerender('79f86886', render)
  })

}


export default __exports__